<template>
	<el-dialog
		:visible.sync="visible"
		:close-on-click-modal="false"
		:show-close="false"
		:title="title"
		:width="width">
		<slot name="content"/>
		<span slot="footer">
			<el-button size="small" class="g-confirm-btn" @click="onComfirm">确 定</el-button>
			<el-button size="small" class="g-cancel-btn" @click="onClose">取 消</el-button>
		</span>
	</el-dialog>

</template>

<script>
export default {
	name: 'comfirmDialog',

	components:{},

	props: {
		width: {
			type: String,
			default: '360px'
		},
		title: {
			type: String,
			default: '提示'
		},
		visible: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
		}
	},

	methods: {
		onClose() {
			this.$emit('on-close');
		},
		onComfirm() {
			this.$emit('on-comfirm');
		}
	},

	computed: {},

	mounted(){
	}
}
</script>

<style lang='scss'>
@import "style/activityDeclaration.scss";

.el-dialog__wrapper{
	display: flex;
	justify-content: center;
	align-items: center;
	.red_font{
		color:#e90e24;
	}
}
</style>
